import { Inject, Injectable } from "@angular/core"
import { DOCUMENT, Title } from "@angular/platform-browser"

import { Merchant } from "./shared/merchant"

@Injectable()
export class SeoService {
  constructor(
    private titleService: Title,
    @Inject(DOCUMENT) private document: any
  ) {}

  public updateTitleAndMetasFromMerchant(merchant: Merchant) {
    const title = `${merchant.name} - Referral Program`
    const description = `Have you tried out ${merchant.name} Yet? ${merchant.referral_program.referred_reward.name}.`
    this.setTitle(title)
    this.setMeta("og:title", title)
    this.setMeta("description", description)
    this.setMeta("og:description", description)
  }

  public setTitle(title: string) {
    this.titleService.setTitle(title)
  }

  public getTitle(): string {
    return this.titleService.getTitle()
  }

  public setMeta(name: string, value: string): SeoService {
    const meta_element = this.getOrCreateMetaElement(name)

    if (meta_element) {
      meta_element.setAttribute("content", value)
    }

    return this
  }

  public getMeta(name: string): string {
    const meta_element = this.getOrCreateMetaElement(name)

    if (meta_element) {
      return meta_element.getAttribute("content")
    }

    return null
  }

  private getOrCreateMetaElement(name: string): HTMLElement {
    let el: HTMLElement = this.document.querySelector(`meta[name='${name}']`)
    if (!el) {
      el = this.document.createElement("meta")
      el.setAttribute("name", name)
      this.document.head.appendChild(el)
    }
    return el
  }
}



// WEBPACK FOOTER //
// /home/runner/work/onelocal/onelocal/src/my-referral/src/app/seo.service.ts